import React from 'react'
import { Typography, Stack, Box, Grid, Divider, Radio, Select, MenuItem, InputLabel, Button, Checkbox, TextField, IconButton } from '@mui/material'
import ContractSuccessIcon from "../../../../Icons/ContractSuccess.svg"
import VisaIcon from "../../../../Icons/Visa.svg"
import Document from "../../../../assets/pending.png"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Success({ setStepperCount }) {
    const navigate = useNavigate()
    const {t} = useTranslation()
    
  return (
    <>
      <Box px={{ md: 10, xs: 3 }}>
        {/* <Typography variant="h6_1">Success</Typography> */}
        <Grid mt={3} mb={6} container rowGap={7}>
          <Grid xs={12} sx={{ display: "flex", flexDirection: "column" }} rowGap={2} gap={2}>
            {/* <Divider /> */}
            <Stack my={10} direction="column" justifyContent="space-between" alignItems="center" gap={1}>
              <Box mb={3} component="img" src={Document}></Box>
              <Typography variant="h6_1">{t("Your Dental Application Has Been Successfully Submitted")}</Typography>
              <Typography variant='h7_2' >{t("Thank you! We’ve received your Dental request.")}</Typography>
              <Button sx={{mt : 2}} variant='contained' onClick={() => navigate('/account')}>{t("Go to dashboard")}</Button>
            </Stack>
          </Grid>
        </Grid>
      </Box>

    </>
  )
}
